import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removePaymentMethod } from '../../api/payment-method.ts';

export default function useRemovePaymentMethod(): UseMutationResult<
  Awaited<ReturnType<typeof removePaymentMethod>>,
  Error
> {
  return useMutation({
    mutationFn: removePaymentMethod,
  });
}
